import { Component, OnInit, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { Alert, AlertService, AlertType, TableComponent, TableConfig } from '@michelin/theme';
import { MatTableDataSource } from '@angular/material/table';
import { TranslationService } from '../../../../shared/translations/services/translation.service';
import { Store } from '@ngxs/store';
import { SetupScreensService } from '../../services/setup-screens.service';
import { PlantSetup } from '../../models/plant-setup.model';
import { Router } from '@angular/router';
import { UpdateSelectedPlantAction } from '../../../../shared/state/DealerState';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-plant-setup-search',
  templateUrl: './plant-setup-search.component.html',
  styleUrl: './plant-setup-search.component.scss',
  standalone: false
})
export class PlantSetupSearchComponent implements OnInit {
  @ViewChild(TableComponent, { static: true }) tableRef: TableComponent<PlantSetup>;

  plants = new MatTableDataSource();

  public translationService = inject(TranslationService);
  public setupScreensService = inject(SetupScreensService);
  public router = inject(Router);
  public alertService = inject(AlertService);
  public store = inject(Store);
  public cdr = inject(ChangeDetectorRef);
  protected readonly environment = environment;

  tableConfig: TableConfig<PlantSetup> = {
    columns: {
      code: {
        cell: (item: PlantSetup) => item.code,
        header: this.translationService.translate('codeText')
      },
      name: {
        cell: (item: PlantSetup) => item.name,
        header: this.translationService.translate('nameText')
      },
      plantNumber: {
        cell: (item: PlantSetup) => item.plantNumber,
        header: this.translationService.translate('plantNumberText')
      },
      status: {
        cell: 'status',
        header: this.translationService.translate('statusColumnText')
      }
    },
    onRowClick: (elm: PlantSetup) => {
      this.store.dispatch(new UpdateSelectedPlantAction(elm));
      this.router.navigateByUrl('/home/setup/plantSetup/' + elm.id);
    }
  };

  addNewPlant(): void {
    this.store.dispatch(new UpdateSelectedPlantAction(null));
    this.router.navigate(['/home/setup/plantSetup/create']);
  }

  ngOnInit(): void {
    this.setupScreensService.getAllPlants().subscribe({
      next: (response) => {
        this.plants = new MatTableDataSource(response.data);
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Error loading getAllPlants:', err);
        this.alertService.showAlert({
          type: AlertType.strong,
          content: this.translationService.translate('tryAgainText')
        } as Alert);
      }
    });
  }
}
